import { ExclamationCircleFilled } from '@ant-design/icons'
import { Modal } from 'antd'

import Box from '~/core/Box'
import Text from '~/core/Text'
import Button from '~/core/Button'
import getColor from '~/lib/getColor'

type MfaErrorModalPropsType = {
    visible: boolean
    onCancel: () => void
}

const PLACEMENT = 'mfa-error-modal'

export default function MfaErrorModal(props: MfaErrorModalPropsType) {
    const { visible, onCancel } = props

    return (
        <Modal
            bodyStyle={{ padding: '24px 12px 12px 24px' }}
            centered
            closable
            footer={null}
            visible={visible}
            onCancel={onCancel}
            afterClose={onCancel}
            width="445px"
            maskClosable
        >
            <Box>
                <ExclamationCircleFilled
                    style={{
                        color: getColor('warning'),
                        fontSize: '21px',
                        marginRight: '18px',
                    }}
                />
                <Box direction="col" flex="1">
                    <Text
                        fontSize="16px"
                        color="blackAlpha65"
                        style={{ marginBottom: '12px', width: '90%' }}
                    >
                        QR code not found
                    </Text>
                    <Text
                        color="blackAlpha65"
                        style={{
                            marginBottom: '48px',
                        }}
                    >
                        We were unable to generate a QR code. Please try logging
                        back into your account and enabling 2FA again.
                    </Text>
                    <Box justifyContent="end">
                        <Button
                            type="primary"
                            onClick={onCancel}
                            name={`${PLACEMENT}-close`}
                            placement={PLACEMENT}
                            data-test-target={`${PLACEMENT}-close`}
                        >
                            Close
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}
